import { ChatHelper, UserHelper } from "../helpers";
import { ChatMessage, LiveChatData, ScreenType, UserRole } from "../types";
import { getInfoMessage } from "../utils/language";

type MessageUserProps = {
    screenType: ScreenType;
    chatHelper?: ChatHelper | null | undefined;
    message?: ChatMessage | null | undefined;
    chatData?: LiveChatData | null | undefined;
    /** Optional suffix after nickname (e.g. report bot model name). Separator added when present. */
    renderUserNameSuffix?: (message: ChatMessage) => React.ReactNode;
};

const MessageUser: React.FC<MessageUserProps> = ({
    screenType,
    chatHelper,
    message,
    chatData,
    renderUserNameSuffix,
}) => {
    if (chatHelper && message && chatHelper.hasFlowMessage(message) !== '') {
        return null;
    }

    let textLocation = 'chatyme-text-start';
    if (screenType === ScreenType.Client) {
        if (message?.sender?.role === UserRole.Client) {
            textLocation = 'chatyme-text-end';
        } else {
            textLocation = 'chatyme-text-start';
        }
    } else if (screenType === ScreenType.Agent) {
        if ([...UserHelper.chatAgentUsers(), undefined].some(x => x === message?.sender?.role)) {
            textLocation = 'chatyme-text-end';
        } else {
            textLocation = 'chatyme-text-start';
        }
    }
    let nickname = getInfoMessage('chatAssistant', chatData, screenType);
    if (message?.sender) {
        nickname = message?.sender?.nickname ?? message?.sender?.name + ' ' + message?.sender?.surname
    }
    const userNameSuffix = message && renderUserNameSuffix ? renderUserNameSuffix(message) : null;

    return (
        <div className={`chatyme-message-item chatyme-message-user-name ${textLocation}`.trim()}>
            {nickname}
            {userNameSuffix ? (
                <>
                    <span className="chatyme-message-user-name-separator"> - </span>
                    {userNameSuffix}
                </>
            ) : null}
        </div>
    );
};

export default MessageUser;